import React from "react";

function NoteAttachmentIndicator({ count = 0, className = "" }) {
  if (!count) {
    return null;
  }

  const label = count === 1 ? "1 attachment" : `${count} attachments`;

  return (
    <span
      className={`my-notes-attachment-indicator ${className}`.trim()}
      title={label}
      aria-label={label}
    >
      <img src="/assets/images/attach-file.png" alt="" aria-hidden="true"  />
    </span>
  );
}

export default NoteAttachmentIndicator;
